import { render } from "./ListDraft.vue?vue&type=template&id=0582b074&scoped=true"
import script from "./ListDraft.vue?vue&type=script&lang=js"
export * from "./ListDraft.vue?vue&type=script&lang=js"

import "./ListDraft.vue?vue&type=style&index=0&id=0582b074&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0582b074"]])

export default __exports__